<template>
  <div>
    <div v-if="mx_is" class="opc-prorated-summary">
      <NextCharge :disable-trigger-preview='true' :ext-loading='mx_loading'>
        <div slot="header">
          <div class="opc-cart__main__divider"></div>
          <div class="opc-cart-item__sub-title">{{ $t('billing.prorated.updated_summary') }}</div>
        </div>
      </NextCharge>
    </div>
    <slot v-else></slot>
  </div>
</template>

<script>
import mx from './mx.vue';
import NextCharge from "../next.vue";
export default {
  mixins: [mx],
  components: {
    NextCharge
  },
};
</script>

<style lang="scss">
.opc-prorated-summary{
  .opc-cart-item__sub-title{
    font-size: 16px;
    margin-bottom: 12px;
  }
  .opc-cart__next__title{
    font-size: 14px;
  }
  .opc-cart__next__value{
    margin-left: 0;
    &::before{
      content: ": ";
    }
  }
}
</style>
